module.exports = __webpack_public_path__ + "static/media/slider-minimal-agency-slide-01-image-01.7528a55d.jpg";